<template>
    <div class="bg-neutral-100 dark:bg-neutral-800 rounded my-4 flex items-center justify-between">
        <div class="p-3 min-w-0 flex-1 cursor-pointer"
             @click="handleTemplateEdit">
            <div>
                {{ template.name }}
            </div>
            <div class="text-xs truncate text-neutral-500 w-full">
                {{ itemSummary }}
            </div>
        </div>
        <button type="button"
                class="mr-3 flex h-9 w-9 shrink-0 items-center justify-center rounded border border-neutral-300 text-neutral-600 hover:border-brand-primary-400 hover:text-brand-primary-500 dark:border-neutral-600 dark:text-neutral-300"
                aria-label="Copy template"
                data-cy="copy-template"
                title="Copy template"
                :disabled="loading"
                @click.stop="handleTemplateDuplicate">
            <Icon :icon="loading ? 'loader' : 'copy'" :class="loading ? 'fa-spin' : null" />
        </button>
    </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: 'ResourceListItem',
  computed: {
    itemSummary() {
      if (this.template.items?.length) {
        const consumedSetIds = new Set();

        return this.template.items.map((item) => {
          if (item.type === 'rest_timer') {
            return `${item.label || 'Rest Timer'} (${this.$timerValue(item.duration || 90)})`;
          }

          const movementId = item.movementId || item.movement_id;
          const movement = this.template.movements.find(movement => movement.id === movementId);
          const setId = item.setId || item.set_id;

          if (setId) {
            if (consumedSetIds.has(setId)) {
              return null;
            }

            consumedSetIds.add(setId);

            const setCount = this.template.items.filter(candidate => {
              return candidate.type === 'movement' && (candidate.setId || candidate.set_id) === setId;
            }).length;

            if (setCount > 1) {
              return `${movement?.name || 'Movement'} x${setCount}`;
            }
          }

          return movement?.name || 'Movement';
        }).filter(Boolean).join(', ');
      }

      return this.template.movements.map(movement => movement.name).join(', ');
    },
    template() {
      return this.resource;
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      templateDuplicate: 'template/duplicate',
    }),
    handleTemplateDuplicate() {
      this.loading = true;

      return this.templateDuplicate({
        id: this.template.uuid,
      }).then((id) => {
        const template = this.$store.getters['template/findBy'](id);
        window.app.snackbar({message: 'Template Copied'});
        this.$router.push(`/template/${template.uuid}/edit`);
      }).finally(() => {
        this.loading = false;
      });
    },
    handleTemplateEdit() {
      this.$router.push(`/template/${this.template.uuid}/edit`);
    },
  },
  props: {
    resource: {
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">

</style>
